firebird.factory('videoGlobalService', [
    '$injector',
    function ($injector) {
        var service = {
            self: null,
            data: null,
            test: false,
            initialize: initialize,
            setLocals: setLocals
        };

        return service;

        // store self and data, and supply values from data to other services as needed.
        function initialize(self, data) {
            service.self = self;
            service.data = data;

            if (self.test) {
                // if videoroomCtrl is in test, change getters.
                // var getter = $injector.get;
                // var newGetter = function(name) {
                //     if (data[name] !== undefined)
                //         return data[name];
                //     else
                //         return getter(name);
                // };
                // $injector.get = newGetter.bind($injector);
            }
        }

        function setLocals() {}
    }
]);
